import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const AREAS = [
  "Belém",
  "Ananindeua",
  "Marituba",
  "Benevides",
  "Castanhal",
  "Santa Izabel do Pará",
  "Região Metropolitana de Belém",
  "BR-316",
  "BR-010",
];

export default function Areas() {
  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="relative bg-brand-black py-24 sm:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-6 border-b border-chrome/15 pb-10">
          <div className="col-span-12 flex items-center gap-4 sm:col-span-4">
            <span className="font-mono text-xs tracking-[0.3em] text-brand-yellow">
              [ SEÇÃO 04 · COBERTURA ]
            </span>
            <span className="h-px flex-1 bg-chrome/20" />
          </div>
          <h2
            data-testid="areas-h2"
            className="col-span-12 font-display text-5xl uppercase leading-[0.9] tracking-tight text-white sm:col-span-8 sm:text-7xl"
          >
            Onde <span className="text-brand-yellow">rebocamos</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-12 gap-6">
          {/* Areas list */}
          <div className="col-span-12 lg:col-span-5">
            <ul className="flex flex-col">
              {AREAS.map((a, i) => (
                <motion.li
                  key={a}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{
                    duration: 0.5,
                    delay: i * 0.05,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                  className="group flex items-center justify-between border-b border-chrome/15 py-4 last:border-b-0"
                  data-testid={`area-${i}`}
                >
                  <div className="flex items-center gap-4">
                    <MapPin className="h-4 w-4 text-brand-yellow" strokeWidth={2} />
                    <span className="font-display text-2xl uppercase tracking-tight text-white transition-colors group-hover:text-brand-yellow sm:text-3xl">
                      {a}
                    </span>
                  </div>
                  <span className="font-mono text-[10px] tracking-[0.3em] text-neutral-500">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Map */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="relative col-span-12 lg:col-span-7"
          >
            <div className="relative aspect-[4/3] w-full overflow-hidden border border-chrome/25 bg-neutral-900">
              <iframe
                title="Mapa Cobertura GORILLAS REBOQUE - Belém, Ananindeua, Marituba"
                data-testid="coverage-map"
                src="https://www.google.com/maps?q=Bel%C3%A9m%2C%20PA%2C%20Brasil&t=&z=10&ie=UTF8&iwloc=&output=embed"
                className="absolute inset-0 h-full w-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ border: 0 }}
                allowFullScreen
              />
              {/* frame corners */}
              <span className="pointer-events-none absolute left-3 top-3 h-4 w-4 border-l-2 border-t-2 border-brand-yellow" />
              <span className="pointer-events-none absolute right-3 top-3 h-4 w-4 border-r-2 border-t-2 border-brand-yellow" />
              <span className="pointer-events-none absolute left-3 bottom-3 h-4 w-4 border-l-2 border-b-2 border-brand-yellow" />
              <span className="pointer-events-none absolute right-3 bottom-3 h-4 w-4 border-r-2 border-b-2 border-brand-yellow" />
              <div className="pointer-events-none absolute bottom-0 left-0 right-0 flex items-end justify-between bg-gradient-to-t from-black/70 to-transparent p-4">
                <span className="font-mono text-[10px] tracking-[0.3em] text-white/90">
                  ZONA DE COBERTURA
                </span>
                <span className="font-mono text-[10px] tracking-[0.3em] text-brand-yellow">
                  BELÉM · PA
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
